import styled from 'styled-components';

export const SignerCollapseHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-right: 32px;
`;
